export interface ResultsScheduleRequest {
  readonly delayMs: number;
  readonly settle?: Promise<unknown> | null;
  readonly isCurrent: () => boolean;
  readonly present: () => void;
}

export interface ResultsTimerPort {
  schedule(callback: () => void, delayMs: number): number | undefined;
  cancel(timer: number): void;
}

/** Owns delayed results presentation and invalidates stale career commits. */
export class ResultsCareerController {
  private generation = 0;
  private timer: number | undefined;
  private visibleValue = false;

  constructor(
    private readonly timers: ResultsTimerPort,
    private readonly onVisibilityChange: (visible: boolean) => void,
  ) {}

  get visible(): boolean {
    return this.visibleValue;
  }

  schedule(request: ResultsScheduleRequest): number {
    this.cancelTimer();
    const generation = ++this.generation;
    this.timer = this.timers.schedule(() => {
      this.timer = undefined;
      void (request.settle ?? Promise.resolve()).then(() => {
        if (generation !== this.generation || !request.isCurrent()) return;
        this.visibleValue = true;
        this.onVisibilityChange(true);
        request.present();
      });
    }, request.delayMs);
    return generation;
  }

  reset(): void {
    this.generation += 1;
    this.cancelTimer();
    if (!this.visibleValue) {
      this.onVisibilityChange(false);
      return;
    }
    this.visibleValue = false;
    this.onVisibilityChange(false);
  }

  dispose(): void {
    this.reset();
  }

  private cancelTimer(): void {
    if (this.timer === undefined) return;
    this.timers.cancel(this.timer);
    this.timer = undefined;
  }
}
